module.exports = __webpack_public_path__ + "static/img/3.36904be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/3.png
// module id = p9XV
// module chunks = 0